import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import ResourceCard from './ResourceCard'

const copy = {
  heading: `Related content`,
}

const cards = [
  {
    resourceType: `Blog`,
    heading: `Identity Resolution Best Practices`,
    description: `In part 1 of our ‘Mastering Identity Resolution blog series' we share best practices that will simplify the complex identity management world.`,
    href: `/blog/identity-resolution-best-practices-for-data-scientists/`,
  },
  {
    resourceType: `Blog`,
    heading: `The Four Biggest Pitfalls of DIY Identity Resolution`,
    description: `In part 2 of our ‘Mastering Identity Resolution blog series', we cover the four biggest pitfalls from data teams who have taken the ‘go it alone’ approach.`,
    href: `/blog/four-biggest-pitfalls-of-diy-identity-resolution/`,
  },
  {
    resourceType: `Blog`,
    heading: `How Identity Resolution Lays the Foundation for Complex Customer En...`,
    description: `In part 3 of our ‘Mastering Identity Resolution blog series’, we showcase how data teams can unlock powerful use cases when they move past maintenance work of identity resolution`,
    href: `/blog/identity-resolution-lays-foundation-for-customer-engagement-solutions/`,
  },
]

const RelatedContent = () => {
  const pageConfig = usePageConfig()

  return (
    <StyledSectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <ColumnTrack columns={1} overrides={{ md: 2, lg: cards.length }}>
          {cards.map((card) => (
            <ResourceCard
              key={card.heading}
              href={getAbsoluteUrl(card.href, pageConfig)}
              resourceType={card.resourceType}
              heading={card.heading}
              description={card.description}
            />
          ))}
        </ColumnTrack>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    max-width: 1280px;
    margin: 0 auto;
    padding-bottom: 64px;
    row-gap: 40px;

    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      row-gap: 64px;
      padding-bottom: 160px;
    }
  }
`

export default RelatedContent
